import type { Hotel } from "@/models/hotel.models";
import { get } from "aws-amplify/api";

export const ConfigApi = {
  /**
   * Fetch the full hotel configuration by hotelId.
   */
  getHotelConfig: async (hotelId: number | string): Promise<Hotel> => {
    const { body, statusCode } = await get({
      apiName: "config",
      path: `/hotels/${hotelId}`,
    }).response;

    if (statusCode && (statusCode < 200 || statusCode >= 300)) {
      throw new Error(
        `[getHotelConfig] Request failed with status ${statusCode}`,
      );
    }

    if (
      !body ||
      typeof (body as unknown as { json?: () => Promise<Hotel> }).json !==
        "function"
    ) {
      throw new Error("[getHotelConfig] Missing JSON body in response");
    }

    return await (body as unknown as { json: () => Promise<Hotel> }).json();
  },
};
